import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Normalizes a tag by removing spaces and using camelCase.
 * e.g., "pixel art" -> "pixelArt"
 */
export function normalizeTag(tag: string): string {
  if (!tag) return tag;
  
  // Remove # if present to normalize the text part
  const hasHash = tag.startsWith('#');
  const cleanTag = hasHash ? tag.substring(1) : tag;
  
  const normalized = cleanTag
    .split(/[\s_-]+/) // Split by space, underscore or hyphen
    .filter(word => word.length > 0)
    .map((word, index) => {
      if (index === 0) return word.toLowerCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
    
  return hasHash ? `#${normalized}` : normalized;
}


